import { render, staticRenderFns } from "./ligne-versement-chip.vue?vue&type=template&id=3858044d&scoped=true"
import script from "./ligne-versement-chip.vue?vue&type=script&setup=true&lang=js"
export * from "./ligne-versement-chip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3858044d",
  null
  
)

export default component.exports